// libs
import styled from "styled-components";

// dls
import { CardContainer } from "@swiggy-private/dls-web-core/dist/components/CardContainer";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

export const StyledParent = styled(CardContainer)(() => ({
    background: "#f0f0f5",
    paddingBottom: "var(--sab, 0px)",
}));

export const Header = styled.div(({ theme }) => ({
    marginBottom: theme.spacing.medium,
}));

export const Content = styled.div(() => ({
    display: "flex",
    flexDirection: "column" as const,
}));

export const EmiPlanSection = styled.div(({ theme }) => ({
    boxShadow: theme.elevation[theme.colorMode].raised.boxShadow,
    background: theme.colors[theme.colorMode].background_Primary,
    padding: `${theme.spacing.small} ${theme.spacing.medium}`,
    borderRadius: theme.cornerRadius.medium,
    marginBottom: theme.spacing.medium,
}));

export const EmiPlanHeader = styled.div(({ theme }) => ({
    marginBottom: theme.spacing.small,
    paddingBottom: theme.spacing.xSmall,
    display: "flex",
    justifyContent: "space-between",
    borderBottom: `1px dashed ${theme.colors[theme.colorMode].border_Subtle_Secondary}`,
}));

export const EmiInterestDetails = styled(Text)(() => ({
    opacity: 1,
}));

export const ProductsList = styled.div(() => ({
    display: "flex",
    flexDirection: "column" as const,
}));
